export const INIT_ORIGINAL_FILE_PK = 'INIT_ORIGINAL_FILE_PK';

export function initOriginalFilePK(originalFilePK){
    return{
        type: INIT_ORIGINAL_FILE_PK,
        mainState: {
            originalFilePK: originalFilePK
        }
    }
}